var map = {
	"./5AGK.png": 32917,
	"./6AGK.png": 71754,
	"components/Catalog/AGK/img/allDoor/lbb/5AGK.png": 32917,
	"components/Catalog/AGK/img/allDoor/lbb/6AGK.png": 71754
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 10234;